module.exports = __webpack_public_path__ + "media/img/frontend_application/up-icon-7dc62b852109b3efed2bd88c9f723f4c.svg";